import React from 'react';
import { BaseFilter, BaseFilterProps } from '../common/BaseFilter';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { FilterProps, FilterStorageKey } from '../common/filter.util';
import { translate } from '../../../../types/translation/Translator';
import ManageTypeFilterContent from './DropdownContent/ManageTypeFilterContent';
import ManageTypeFilterInnerContent from './DropdownContent/ManageTypeFilterInnerContent';
import PackageIcon from '../../../icons/Package/PackagIcon';
import { toFilterString } from '../../../../util/string.util';
import {
  ProductMasterData,
  ProductMasterDataManageType,
} from '../../../../types/product_master_data/productMasterData';

export class ManageTypeFilter extends BaseFilter<ProductMasterDataManageType> {
  constructor() {
    super(FilterStorageKey.MANAGE_TYPE);
  }

  filterOptions = () => [];

  toLabel(): string {
    return translate({ key: TranslationKey.manageType });
  }

  toInnerContent(props: BaseFilterProps): string | JSX.Element {
    return (
      <ManageTypeFilterInnerContent
        filter={this}
        filterProps={props.filterProps}
        setFilterProps={props.setFilterProps}
      />
    );
  }

  toDropdownContent(props: BaseFilterProps): React.JSX.Element {
    return (
      <ManageTypeFilterContent filter={this} filterProps={props.filterProps} setFilterProps={props.setFilterProps} />
    );
  }

  toIcon(): React.JSX.Element {
    return <PackageIcon />;
  }

  toCount(props: BaseFilterProps): number {
    return props.filterProps.manageType?.size || 0;
  }

  search(item: ProductMasterDataManageType, filter: string) {
    const filterString = toFilterString(filter);

    if (!filterString) return true;

    return toFilterString(ManageTypeFilter.toText(item)).includes(filterString);
  }

  filteredItems(
    items: ProductMasterDataManageType[],
    query: string,
    filterProps: FilterProps,
  ): ProductMasterDataManageType[] {
    return items.filter(item => this.search(item, query));
  }

  static filter(filterProps: FilterProps, item: ProductMasterData | undefined): boolean {
    if (!item) return true;

    const selected = filterProps.manageType;
    const itemTypes = ProductMasterData.manageTypesFrom(item);

    if (!selected?.size) return true;
    return [...selected].some(type => itemTypes.has(type));
  }

  static toText(manageType: ProductMasterDataManageType): string {
    switch (manageType) {
      case ProductMasterDataManageType.serial:
      case ProductMasterDataManageType.lpn:
      case ProductMasterDataManageType.lot:
      case ProductMasterDataManageType.kit:
      case ProductMasterDataManageType.quantity:
        return translate({ key: manageType });
      default:
        return translate({ key: TranslationKey.unknown });
    }
  }
}
